import { icon } from "leaflet";
import circle from '../../../assets/images/circle.png';
import circleVerde from '../../../assets/images/circle-verde.png';
import circleVioleta from '../../../assets/images/circle-violeta.png';
import circleNaranja from '../../../assets/images/circle-naranja.png';
import circleAmarillo from '../../../assets/images/circle-amarillo.png';

// Crea los iconos con los colores personalizados
export const OrangeIcon = new icon({
  iconUrl: circleNaranja,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

export const greenIcon = new icon({
  iconUrl: circleVerde,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

export const redIcon = new icon({
  iconUrl: circle,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

export const yellowIcon = new icon({
  iconUrl: circleAmarillo,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

export const VioletIcon = new icon({
  iconUrl: circleVioleta,
  iconSize: [14, 14],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

export const getIcon = (type, category = '') => {
  const combined = `${type} ${category}`.toLowerCase();
  if (/basur|residuos|residuo|basurero/.test(combined)) return VioletIcon;
  if (/bache|dan(o|os)/.test(combined)) return redIcon;
  if (/arbol|arboles|rbol|arbo/.test(combined)) return greenIcon;
  if (/alumbrado|luminaria|alumbrad|lumbrado/.test(combined)) return OrangeIcon;
  if (/semaforo|semafor|emaforo|foro/.test(combined)) return yellowIcon;
  if (/señal|horiz|linea|cebra|demarc|pintura|senda|peaton|flecha|símbolo|simbolo/.test(combined)) return VioletIcon;
  return greenIcon;
};

export const isValidCoordinate = (lat, lng) => {
  const latNum = parseFloat(lat);
  const lngNum = parseFloat(lng);
  return !isNaN(latNum) && !isNaN(lngNum) && latNum !== 0 && lngNum !== 0 && Math.abs(latNum) <= 90 && Math.abs(lngNum) <= 180;
};

// --- HELPER PARA ACCESO A JSON_DATA ---

export const getJsonValue = (item, field, defaultValue = null) => {
  if (!item) return defaultValue;
  const val = item?.json_data?.[field];
  return val !== undefined && val !== null ? val : defaultValue;
};

// --- LÓGICA DE NEGOCIO PARA PRIORIDAD Y EMPRESA ---

const jv = (item, field, def) => getJsonValue(item, field, def);

export const calculatePriorityResult = (item) => {
  if (!item) return 'Baja';
  const enCalzada = jv(item, 'en_calzada');
  const animalMuerto = jv(item, 'animal_muerto');
  const acumulacion = jv(item, 'acumulacion');

  if (enCalzada == 'calzada' || enCalzada == 'parcial' || animalMuerto === '1' || animalMuerto === 1) {
    return 'ALTA';
  } else if (acumulacion === '1' || acumulacion === 1) {
    return 'Media';
  }
  return 'Baja';
};

export const calculateAssignedCompany = (item) => {
  if (!item) return 'GRUPO L';
  const tipoPrincipal = jv(item, 'tipo_principal');
  const bolsasRotas = jv(item, 'bolsas_rotas_dispersion');

  if (tipoPrincipal === 'bolsas' && bolsasRotas !== '1') {
    return 'SANTA ELENA';
  }
  return 'GRUPO L';
};

export const getPriorityTheme = (prioridad) => {
  switch (prioridad) {
    case 'ALTA': return { color: '#e55353', bg: '#fee2e2' }; // Rojo
    case 'Media': return { color: '#f9b115', bg: '#fef3c7' }; // Amarillo/Naranja
    default: return { color: '#3399ff', bg: '#e0f2fe' }; // Azul
  }
};
